import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './LoginPageLayout.module.css';
export type LoginPageLayoutProps = ComponentProps<'div'>;
export const LoginPageLayout: FunctionComponent<LoginPageLayoutProps> = React.memo(props => {
  const $ = _c(11);
  let children;
  let t0;
  let t1;
  if ($[0] !== props) {
    const {
      children: t2,
      className,
      ...remainingProps
    } = prepareProps({
      props
    });
    children = t2;
    t0 = remainingProps;
    t1 = classes(className, styles.pageWrapper);
    $[0] = props;
    $[1] = children;
    $[2] = t0;
    $[3] = t1;
  } else {
    children = $[1];
    t0 = $[2];
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={styles.headerPlaceholder}><header className={styles.fixedContent}><div className={styles.header} /></header></div>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children) {
    t3 = <main className={styles.contentWrapper}>{children}</main>;
    $[5] = children;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t0 || $[8] !== t1 || $[9] !== t3) {
    t4 = <div {...t0} className={t1}>{t2}{t3}</div>;
    $[7] = t0;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
});